import l from "./index846.js";
import s from "./index840.js";
import u from "./index920.js";
import a from "./index856.js";
var p = Object.prototype, m = p.hasOwnProperty;
function P(t, r) {
  r = l(r, t);
  var o = -1, e = r.length;
  if (!e)
    return !0;
  for (var f = t == null || typeof t != "object" && typeof t != "function"; ++o < e; ) {
    var n = r[o];
    if (typeof n == "string") {
      if (n === "__proto__" && !m.call(t, "__proto__"))
        return !1;
      if (n === "constructor" && o + 1 < e && typeof r[o + 1] == "string" && r[o + 1] === "prototype") {
        if (f && o === 0)
          continue;
        return !1;
      }
    }
  }
  var i = u(t, r);
  return i == null || delete i[a(s(r))];
}
export {
  P as default
};
